import { useEffect, useState } from "react";
import { makeStyles, withStyles, InputBase } from "@material-ui/core";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useStylesApp } from "hooks/useStyles";
import bigDecimal from "js-big-decimal";
//Notificacion errores https://iamhosseindhv.com/notistack/demos#variants
import { useSnackbar } from "notistack";
import uuid from "react-uuid";
import { notNull } from "utils/checkInputs";
import moment from "moment";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    margin: theme.spacing(1),
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "1%",
    borderStyle: "solid",
    borderBottomWidth: "5px",
    borderRadius: "4px",
  },
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  divForm: {
    marginBottom: "1%",
  },
  divInput: {
    marginBottom: "1%",
    paddingRight: "1%",
    paddingLeft: "0.5%",
  },
  divSelect: {
    width: "100%",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
    marginBottom: "1%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  haedClient: {
    backgroundColor: palette.primary.light,
    width: "10%",
    marginBottom: "2%",
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "1%",
    borderStyle: "solid",
    borderBottomWidth: "5px",
    borderRadius: "4px",
  },
}));

export default function useMultiplePayments(
  informacionPagos,
  setInformacionPagos,
  viewPago,
  setViewPago,
  totals
) {
  const classes = useStyles();
  const classesApp = useStylesApp();
  const classesGlobal = useStylesGlobal();
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [pago, setPago] = useState({
    id: uuid(),
    valorCuota: "",
    informacionInteres: null,
  });
  const [fecVencimiento, setFecVencimiento] = useState("");

  const [empty, setEmty] = useState({
    fechaVencimiento: true,
    valorCuota: true,
    informacionInteres: true,
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    cleanPago();
    setOpen(false);
  };

  useEffect(() => {
    setPago({
      ...pago,
      fechaVencimiento: moment(fecVencimiento).format("YYYY-MM-DDTHH:MM:ssZ"),
    });
  }, [fecVencimiento])

  const hadleAddPago = () => {
    const errors = validationInputs();
    setEmty(errors);
    let isValid =
      Object.values(errors).filter((item) => item === false).length === 0;
    isValid =
      isValid && errors.valorCuota === null && errors.fechaVencimiento === null && errors.informacionInteres === null;
    if (isValid) {
      if (informacionPagos.length > 0) {
        setInformacionPagos([...informacionPagos, pago]);
      } else {
        setInformacionPagos([pago]);
      }
      if (viewPago === 1) {
        setViewPago(2);
      } else {
        setViewPago(1);
      }
      handleClose();
      enqueueSnackbar(`Información de pago a plazo agregado`, {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        autoHideDuration: 4000,
      });
    }
  };

  const handleChangeUniversal = (event) => {
    setPago({
      ...pago,
      [event.target.name]: event.target.value,
    });
  };

  const handleChange = (event) => {
    event.preventDefault();
    const re = /^[0-9\b]{1,14}$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      setPago({
        ...pago,
        [event.target.name]: event.target.value,
      });
    }
  };

  const handleChangeTotal = (event) => {
    event.preventDefault();
    const re = /^[0-9\b.]{1,14}$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      if (Number(event.target.value.trim()) >= 0) {
        setPago({
          ...pago,
          [event.target.name]: event.target.value,
        });
      }
    }
  };

  const validateDecimal = (numberValor) => {
    let splitList = numberValor.split(".");
    if (splitList.length > 2) {
      return `El dato ingresado es erroneo utilice punto (.) para separar decimales`;
    } else if (splitList.length > 1) {
      if (splitList[1].length > 6) {
        return `El dato ingresado debe tener solo 6 decimales Ej, 12.43`;
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const validateMultiplePayment = () => {
    let sum = informacionPagos.reduce(function (acc, pago) {
      return Number(acc) + Number(pago.total);
    }, 0);

    return sum;
  };

  const cleanPago = () => {
    setPago({
      id: uuid(),
      valorCuota: "",
      informacionInteres: null,
    });
    setFecVencimiento("");
    setEmty({
      fechaVencimiento: true,
      valorCuota: null,
      informacionInteres: null,
    });
  };

  const validationInputs = () => {
    let errors = {};
    errors.fechaVencimiento = notNull(fecVencimiento)
      ? null
      : "Ingrese la fecha de vencimiento de la cuota, es necesario.";
    errors.valorCuota = notNull(pago.valorCuota)
      ? null
      : "Ingrese el valor de la cuota, es necesario.";
    if (errors.valorCuota === null) {
      errors.valorCuota = validateDecimal(pago.valorCuota.toString());
    }
    if (Number(pago.valorCuota) === 0) {
      errors.valorCuota = "No puede ser un valor menor o igual a cero";
    }

    if (
      !(
        Number(bigDecimal.add(validateMultiplePayment(), pago.valorCuota)) <=
        Number(bigDecimal.add(totals.totalFactura, totals.totalPropina))
      )
    ) {
      errors.valorCuota = `El valor es: ${Number(
        bigDecimal.add(validateMultiplePayment(), pago.valorCuota)
      )}, y excede al valor total`;
    }
    errors.informacionInteres = notNull(pago.informacionInteres)
      ? pago.informacionInteres.length < 15 || pago.informacionInteres.length > 1000
        ? errors.informacionInteres = "El tamaño de la información de interés debe estar entre 15 y 1000."
        : null
      : null;

    return errors;
  };

  const summation = () => {
    let sumTotal = bigDecimal.round(
      bigDecimal.subtract(
        bigDecimal.add(totals.totalFactura, totals.totalPropina),
        validateMultiplePayment()
      ),
      2,
      bigDecimal.RoundingModes.HALF_UP
    );
    return sumTotal;
  };

  return {
    setPago,
    palette,
    classes,
    classesApp,
    classesGlobal,
    open,
    pago,
    empty,
    handleClickOpen,
    handleClose,
    hadleAddPago,
    handleChange,
    handleChangeUniversal,
    fecVencimiento,
    setFecVencimiento,
    handleChangeTotal,
    validateDecimal,
    validateMultiplePayment,
    cleanPago,
    validationInputs,
    summation,
  };
}

export const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 15,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);
